import { animate, style, transition, trigger } from "@angular/animations";

export class ToggleAnimator {
  public static toggle  = () => trigger('toggle', [
    transition(':enter', [
      style({
        opacity: 0,
        height: '0',
        overflow: 'hidden'
      }),
      animate(
        '300ms ease-in-out',
        style({
          opacity: 1,
          height: '*'
        })
      )
    ]),
    transition(':leave', [
      style({
        opacity: 1,
        height: '*',
        overflow: 'hidden'
      }),
      animate(
        '300ms ease-in-out',
        style({
          opacity: 0,
          height: '0'
        })
      )
    ])
  ]);
}
